import { Component, Input } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';
import { EventsWyswygService } from 'src/app/shared/services/events-wyswyg.service';
@Component({
  selector: 'app-quiz-rendered',
  templateUrl: './quiz-rendered.component.html',
  styleUrls: ['./quiz-rendered.component.css']
})
export class QuizRenderedComponent extends ElementComponent {
  @Input() override data: any = {
    question: 'Enunciado',
    test: true,
    answers: [{ id: 0, text: "", correct: false },],
    sent: false,
    correctionMessage: '',
    correctionMessageClass: '', // 'correct' 'incorrect' ''
    uniqueAnswers: false,
  }
  answerClass: string[] = [] // 'correct' 'incorrect' ''

  modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      // ['blockquote', 'code-block'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'align': [] }],
      ['clean'],                                         // remove formatting button
      ['link']                         // link and image, video
    ]
  };


  constructor(
    private eventsService?: EventsWyswygService
    ){
    super()
  }


  multipleAnswers(): boolean {
    return this.data.test ?
      this.data.answers.filter(a => a.correct).length > 1 : false;
  }

  saveAnswer(): void {
    this.retryQuiz(); //Para limpiar el estado de las respuestas y poder volver a responder
    this.eventsService!.onAnswerSaved(this.id!);
    //TODO: Eliminado por refactorización
    /*if (this.data.correctAnswers != null && this.data.correctAnswers.length !== 0) {
      this.checkAnswers();
    }*/
    if(this.data.uniqueAnswers){
      this.data.locked = true;
    }
  }

  retryQuiz(): void {
    this.data.sent = false;
    this.data.answers.map(answer => {
      answer.status = '';
    })
  }

  //TODO: Eliminado por refactorización
  /*isCorrect(index: number): boolean {
    return this.data.correctAnswers?.includes(this.data.answers[index].id);
  }*/

  public correctQuiz(result: number): void {
    this.data.attempt = (this.data.attempt || 0) + 1;

        if (this.data.uniqueAnswers) {
          this.data.answers.forEach(answer => {
            if (answer.checked) {
              answer.status = 'sent';
            }
          });
          this.data.correctionMessage = "Respuesta enviada";
          this.data.correctionMessageClass = "sent";
        } else {
          switch (result) {
            case 0: // incorrecto
              this.data.answers.forEach(answer => {
                if (answer.checked) {
                  answer.status = 'incorrect';
                }
              });
              this.data.correctionMessage = "Incorrecto";
              this.data.correctionMessageClass = "incorrect";
              break;
            
            case 1: // correcto
              this.data.answers.forEach(answer => {
                if (answer.checked) {
                  answer.status = 'correct';
                }
              });
              this.data.correctionMessage = "Correcto";
              this.data.correctionMessageClass = "correct";
              break;
            
            case 2: // parcialmente correcto
              this.data.answers.forEach(answer => {
                if (answer.checked) {
                  answer.status = 'correct';
                }
              });
              this.data.correctionMessage = "Parcialmente correcto";
              this.data.correctionMessageClass = "correct";
              break;
          }
        }

        this.data.sent = true;
  }

  isAnyAnswerChecked(): boolean {
    return this.data.answers.some(answer => answer.checked);
  }

  //TODO: Eliminado por refactorización
  /*public checkAnswers(): void {
    !!this.data.attempt? 1: this.data.attempt += 1;
    let correct = 0;
    let incorrect = 0;
    this.data.answers.map(answer => {
      if (!answer.checked) return answer; // no corregimos las no marcadas

      if (this.data.correctAnswers.includes(answer.id)) {
        if(this.data.uniqueAnswers){
          answer.status = 'sent';
        }else{
          answer.status = 'correct';
        }
        correct+=1;
      } else {
        if(this.data.uniqueAnswers){
          answer.status = 'sent';
        }else{
          answer.status = 'incorrect'
        }
        incorrect+=1;
      }
    });

    if(this.data.uniqueAnswers){
      this.data.correctionMessage = "Respuesta enviada";
      this.data.correctionMessageClass = "sent";
    }else{
      switch (incorrect) {
        case 0:
          if (correct === 0) break;
          if (correct === this.data.correctAnswers.length) {
            this.data.correctionMessage = "Correcto";
            this.data.correctionMessageClass = "correct";
            break;
          } else {
            this.data.correctionMessage = "Parcialmente correcto";
            this.data.correctionMessageClass = "correct";
            break;
          }
        default:
          this.data.correctionMessage = "Incorrecto";
          this.data.correctionMessageClass = "incorrect";
          break;
      }
    }

    this.data.sent = true;

  }*/
}
